<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Data Unit" subTitle="Forms" />

    <ListUnit />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import ListUnit from "@/components/Pages/Master/Unit/ListUnit.vue";

export default defineComponent({
  name: "ListUnitPage",
  components: {
    PageTitle,
    ListUnit,
  },
});
</script>
